
/**
 * 콘텐츠 타입
 */
export type UpdateCourseDraft200SectionsItemLecturesItemContentType = typeof UpdateCourseDraft200SectionsItemLecturesItemContentType[keyof typeof UpdateCourseDraft200SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
